import React, { useState } from 'react';
import { useData } from '../../data/DataProvider';
import { useToast } from '../../shared/components/ToastProvider';

export default function Team() {
  const { data, add } = useData();
  const { notify } = useToast();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', role: 'agency_staff' });

  const invite = async (event) => {
    event.preventDefault();
    try {
      const created = await add('team', { ...form, status: 'invited' });
      setOpen(false);
      notify(created?.tempPassword ? `Invited. Temporary password: ${created.tempPassword}` : 'Team member invited');
    } catch (err) {
      notify(err.message || 'Failed to invite team member', 'error');
    }
  };

  return <section className="panel settings-form"><div className="panel-head"><h3>Team</h3><button className="primary-button" onClick={() => setOpen(true)}>Invite team member</button></div>{data.team.map((member) => <div className="config-row" key={member.id}><strong>{member.name}</strong><span>{member.email}</span><Status>{member.role}</Status><span>{member.status}</span></div>)}{open && <form className="drawer-form" onSubmit={invite}><input placeholder="Name" value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} /><input placeholder="Email" type="email" value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} /><select value={form.role} onChange={(event) => setForm({ ...form, role: event.target.value })}><option>agency_staff</option><option>agency_admin</option></select><button className="primary-button">Invite</button></form>}</section>;
}

function Status({ children }) {
  return <span className="status-pill status-sent">{children}</span>;
}
